import useAuthStore from "../../store/authStore";
import styles from "./WelcomeScreen.module.css";

const features = [
  { icon: "💬", title: "Instant Messaging", desc: "Send messages in real time with live delivery updates." },
  { icon: "⚡", title: "Real-Time Delivery", desc: "Messages arrive instantly with live typing indicators." },
  { icon: "🎤", title: "Voice Messages", desc: "Record and send voice messages with one tap." },
  { icon: "👥", title: "Group Chats", desc: "Create groups, add members, and manage with admin controls." },
];

const WelcomeScreen = () => {
  const { user } = useAuthStore();
  return (
    <div className={styles.wrap}>
      <div className={styles.hero}>
        <div className={styles.logoRing}>
          <span className={styles.logoEmoji}>💬</span>
        </div>
        <h1 className={styles.greeting}>
          Hello, {user?.name?.split(" ")[0]} 👋
        </h1>
        <p className={styles.sub}>
          Select a conversation to start chatting, or click the edit icon to start a new one.
        </p>
      </div>

      <div className={styles.grid}>
        {features.map((f) => (
          <div key={f.title} className={styles.card}>
            <span className={styles.cardIcon}>{f.icon}</span>
            <span className={styles.cardTitle}>{f.title}</span>
            <span className={styles.cardDesc}>{f.desc}</span>
          </div>
        ))}
      </div>

      <p className={styles.e2e}>✨ Chatify — fast, reliable messaging</p>
    </div>
  );
};
export default WelcomeScreen;
